/*
  Product page delivery estimate.

  Fails silent by design: if the service is slow, down, or has no rate for the
  visitor's country, the line never appears and the page is unchanged. It is
  supplementary information, so it must never block or break the buy button.
*/
(function () {
  'use strict';

  var TIMEOUT_MS = 5000;

  function request(el) {
    if (el.dataset.etaLoaded) return;
    el.dataset.etaLoaded = '1';
    el.hidden = true;

    var params = new URLSearchParams();
    if (el.dataset.country) params.set('country', el.dataset.country);
    params.set('profile', el.dataset.profile || '');
    if (el.dataset.type) params.set('type', el.dataset.type);

    var grams = parseInt(el.dataset.weight, 10);
    if (grams > 0) params.set('weight_g', String(grams));

    // "4" or a range "5-10" (the store's lead time; an en dash is normalised).
    var handling = String(el.dataset.handling || '').trim().replace(/[–—]/g, '-');
    if (/^\d{1,2}(-\d{1,2})?$/.test(handling)) params.set('handling_days', handling);

    var controller = 'AbortController' in window ? new AbortController() : null;
    var timer = window.setTimeout(function () {
      if (controller) controller.abort();
    }, TIMEOUT_MS);

    fetch(el.dataset.endpoint + '?' + params.toString(), {
      method: 'GET',
      headers: { Accept: 'application/json' },
      credentials: 'omit',
      signal: controller ? controller.signal : undefined
    })
      .then(function (response) {
        return response.ok ? response.json() : null;
      })
      .then(function (data) {
        window.clearTimeout(timer);
        if (data && data.available) render(el, data);
      })
      .catch(function () {
        window.clearTimeout(timer);
      });
  }

  // A bare "en" formats US-style ("Oct 1"); the store is European, so it
  // reads as "1 Oct". Every other locale keeps its own convention.
  function formatter() {
    var lang = document.documentElement.lang || 'en';
    if (/^en$/i.test(lang)) lang = 'en-GB';
    try {
      return new Intl.DateTimeFormat(lang, { day: 'numeric', month: 'short' });
    } catch (error) {
      return new Intl.DateTimeFormat('en-GB', { day: 'numeric', month: 'short' });
    }
  }

  function render(el, data) {
    var format = formatter();
    // Midday avoids the date sliding a day in negative UTC offsets.
    var from = new Date(data.from + 'T12:00:00');
    var to = new Date(data.to + 'T12:00:00');
    var text;

    if (data.from === data.to) {
      text = (el.dataset.single || 'Arrives [date]').replace('[date]', format.format(to));
    } else {
      text = (el.dataset.range || 'Arrives [from] to [to]')
        .replace('[from]', format.format(from))
        .replace('[to]', format.format(to));
    }

    var target = el.querySelector('[data-product-eta-text]') || el;
    target.textContent = text;
    el.hidden = false;
  }

  function variants(el) {
    var node = el.parentElement && el.parentElement.querySelector('[data-product-eta-variants]');
    if (!node) return null;
    try { return JSON.parse(node.textContent); } catch (error) { return null; }
  }

  // Themes put the selected variant in the URL after a change; follow that.
  function selectedVariant() {
    return new URLSearchParams(window.location.search).get('variant');
  }

  function refresh(el) {
    var id = selectedVariant();
    if (!id || id === el.dataset.variant) return;
    var all = variants(el);
    var v = all && all[id];
    if (!v) return;
    el.dataset.variant = id;
    el.dataset.weight = String(v.weight || 0);
    el.dataset.handling = v.handling === null || v.handling === undefined ? '' : String(v.handling);
    delete el.dataset.etaLoaded;
    el.hidden = true;
    if (v.ships === false) return;
    request(el);
  }

  // The theme's "made to order · N days" line above the buy button prints a
  // fixed number; the store's lead time (shop.metafields.arachne.lead_time,
  // kept by lead-time:update) rides along on the snippet and replaces it, so
  // the product page says what the cart and the estimate say.
  function syncLeadTime(el) {
    var lead = String(el.dataset.leadTime || '').trim().replace(/[–—]/g, '-');
    if (!/^\d{1,2}(-\d{1,2})?$/.test(lead)) return;
    Array.prototype.forEach.call(document.querySelectorAll('.product__lead-time'), function (line) {
      var walker = document.createTreeWalker(line, NodeFilter.SHOW_TEXT);
      var node;
      while ((node = walker.nextNode())) {
        if (/\d+\s*[-–—]\s*\d+|\b\d+\b/.test(node.nodeValue)) {
          node.nodeValue = node.nodeValue.replace(/\d+\s*[-–—]\s*\d+|\b\d+\b/, lead.replace('-', '–'));
          return;
        }
      }
    });
  }

  function init() {
    var nodes = document.querySelectorAll('[data-product-eta]');
    Array.prototype.forEach.call(nodes, function (el) {
      syncLeadTime(el);
      if (!el.dataset.variant) el.dataset.variant = selectedVariant() || '';
      if (el.dataset.ships === 'false') return;
      request(el);
    });
  }

  function onVariantMaybeChanged() {
    window.setTimeout(function () {
      Array.prototype.forEach.call(document.querySelectorAll('[data-product-eta]'), refresh);
    }, 50);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
  document.addEventListener('change', onVariantMaybeChanged, true);
  window.addEventListener('popstate', onVariantMaybeChanged);
})();
